export const MAINTENANCE_PATH = '/maintenance';

export type BootMode = 'app' | 'maintenance' | 'probe';

/**
 * `maintenance`: the front flag is on, every route shows the page.
 * `probe`: flag off but on /maintenance — show the page only while the API still answers maintenance.
 */
export const bootMode = (flag: string | undefined, pathname: string): BootMode => {
  if (flag === 'true') return 'maintenance';
  if (pathname.replace(/\/+$/, '') === MAINTENANCE_PATH) return 'probe';
  return 'app';
};
